import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { IStyled } from '../../styles/types';

interface IProps extends IStyled {
  children: ReactNode;
  noMargin?: boolean;
}

const Container = styled.div<{ $noMargin?: boolean }>`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  width: 100%;
  ${({ $noMargin }) =>
    !$noMargin &&
    css`
      margin-bottom: 24px;
    `}
`;

const VerticalField = ({ children, className, noMargin }: IProps) => (
  <Container className={className} $noMargin={noMargin}>
    {children}
  </Container>
);

export default VerticalField;
